import {get} from 'lodash';

export const processCurrencyWithdrawalSupportMethod = (rawData) => {
    // try {
    return {
        rawData,
        id: get(rawData, 'id'),
        currency: get(rawData, 'currency'),
        paymentType: get(rawData, 'paymentType'),
        isLocal: get(rawData, 'paymentType') === 'L',
        isInternational: get(rawData, 'paymentType') === 'I',
        routeType: get(rawData, 'routeType'),
        type: get(rawData, 'type'),
        createdAt: get(rawData, 'createdAt'),
        updatedAt: get(rawData, 'updatedAt'),
        requireRule: JSON.parse(get(rawData, 'requireRule')),
        feeModel: get(rawData, 'feeModel'),
        feeValue: Number(get(rawData, 'feeValue')),
    };
    // } catch (error) {
    //     console.log(rawData.id, get(rawData, 'requireRule'));
    // }
};
